module.exports = __webpack_public_path__ + "fonts/icomoon.06db946.woff";